var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"emoji-icon",class:("emoji-icon_" + _vm.name)},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.innerValues[_vm.name])}})])}
var staticRenderFns = []

export { render, staticRenderFns }